var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { class: _vm.containerClass },
        [
          _c(
            "transition",
            {
              attrs: { name: _vm.guaranteedOverlayTransition },
              on: {
                "before-enter": _vm.beforeOverlayTransitionEnter,
                "after-enter": _vm.afterOverlayTransitionEnter,
                "before-leave": _vm.beforeOverlayTransitionLeave,
                "after-leave": _vm.afterOverlayTransitionLeave,
              },
            },
            [
              _vm.visibility.overlay
                ? _c(
                    "div",
                    {
                      staticClass: "vm--overlay",
                      attrs: {
                        "data-modal": _vm.name,
                        "aria-expanded": _vm.visibility.overlay.toString(),
                      },
                      on: {
                        click: function ($event) {
                          if ($event.target !== $event.currentTarget) {
                            return null
                          }
                          $event.stopPropagation()
                          return _vm.onOverlayClick($event)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "vm--top-right-slot" },
                        [_vm._t("top-right")],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._ssrNode(" "),
          _c(
            "transition",
            {
              attrs: { name: _vm.guaranteedModalTransition },
              on: {
                "before-enter": _vm.beforeModalTransitionEnter,
                "after-enter": _vm.afterModalTransitionEnter,
                "before-leave": _vm.beforeModalTransitionLeave,
                "after-leave": _vm.afterModalTransitionLeave,
              },
            },
            [
              _vm.visibility.modal
                ? _c(
                    "div",
                    {
                      ref: "modal",
                      class: _vm.modalClass,
                      style: _vm.modalStyle,
                      attrs: {
                        "aria-expanded": _vm.visibility.modal.toString(),
                        role: "dialog",
                        "aria-modal": "true",
                      },
                    },
                    [
                      _vm._t("default"),
                      _vm._v(" "),
                      _vm.resizable && !_vm.isAutoHeight
                        ? _c("resizer", {
                            attrs: {
                              "min-width": _vm.minWidth,
                              "min-height": _vm.minHeight,
                              "max-width": _vm.maxWidth,
                              "max-height": _vm.maxHeight,
                              "viewport-height": _vm.viewportHeight,
                              "viewport-width": _vm.viewportWidth,
                              "resize-indicator": _vm.resizeIndicator,
                              "resize-edges": _vm.resizeEdges,
                            },
                            on: { resize: _vm.onModalResize },
                          })
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }